/**
 * Template: Custom Page Builder
 * -----------------------------------------------------------------------------
 * Scripts to execute in the Custom Page Builder.
 *
 */
import {load} from '@shopify/theme-sections';

/* import '~/sections/image-slider'; */
import '../sections/image-video-hero';
import '../sections/block-50-50';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
